// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExportApiKeySettings-module__button--lHLPk{width:200px;height:34px;color:#fff;font-weight:700;background-color:#35b840;border-radius:6px;font-size:13px;padding:0 15px;border:none}.ExportApiKeySettings-module__button--lHLPk:hover{background-color:#30a63a}.ExportApiKeySettings-module__text--KjkIN{font-size:13px;color:#7b7f83}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ExportApiKeySettings-module__button--lHLPk`,
	"text": `ExportApiKeySettings-module__text--KjkIN`
};
export default ___CSS_LOADER_EXPORT___;
